"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = empty;
function empty(Element) {
    while (Element.lastChild) {
        Element.removeChild(Element.lastChild);
    }
    return Element;
}


//////////////////
// WEBPACK FOOTER
// ./~/kompo-util/lib/empty.js
// module id = 21
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11